<script>
  export let id;

  let title = "Blog - CodeWorld";
  $: updatedTitle = title;

  import StoryblokClient from "storyblok-js-client";
  let accessToken = __myapp.env.STORYBLOK_KEY;

  let Storyblok = new StoryblokClient({
    accessToken
  });

  async function get() {
    const res = await Storyblok.get(`cdn/stories/blog/${id}`, {});
    console.log(res);
    return res;
  }

  let promise = get();
</script>

<svelte:head>
  <title>{updatedTitle}</title>
</svelte:head>

<div class="container">
  <div class="section text-center">
    <div class="card card-body">
      {#await promise}
        loading
      {:then res}
        <div class="prose mx-auto">
          <h1>{res.data.story.content.title}</h1>
          {res.data.story.content.intro}
          <img
            src={res.data.story.content.image}
            alt="blog preview"
            class="w-40 mx-auto" />
          <article class="text-left mx-auto">
            {@html Storyblok.richTextResolver.render(res.data.story.content.long_text)}
          </article>
        </div>
      {:catch error}
        failed with {error}
      {/await}
    </div>
  </div>
</div>
